import { render, staticRenderFns } from "./DesktopClassSelector.vue?vue&type=template&id=aca6e30c&scoped=true"
import script from "./DesktopClassSelector.vue?vue&type=script&lang=js"
export * from "./DesktopClassSelector.vue?vue&type=script&lang=js"
import style0 from "./DesktopClassSelector.vue?vue&type=style&index=0&id=aca6e30c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca6e30c",
  null
  
)

export default component.exports